import { handleValidationChange } from "../CommonValidations/CommonValidaions";

export const validatePrescription = (data, setError) => {
  var isValid = true;

  if (data.prescription_name === "") {
    handleValidationChange("prescription_name", true, setError);
    isValid = false;
  } else {
    handleValidationChange("prescription_name", false, setError);
  }

  return isValid;
};

export const validatePrescriptionDetails = (data) => {
  var isGeneric= false;
  var isPrep = false;
  data.forEach((item) => {
    if(data.length === 0){
      isGeneric= true;
      isPrep = true;
    } else {
        if (item.generic === "" || item.generic === null) {
            isGeneric = true;
        } else {
            isGeneric = false;
        }

        if (item.preparation === "" || item.preparation === null) {
            isPrep = true;
        } else {
            isPrep = false;
        }
    }

  });

  return isGeneric || isPrep;
};
